import React from 'react';
import Relay from 'react-relay';

import DateField from './DateField';
import TextField from './TextField';
import Select from 'react-select';
import Dialog from 'react-bootstrap-dialog';

import UserList from './UserList'

import { isValidEmailAddress } from './UserPanel'

import {cloneDeep} from 'lodash';

export const getOptionsFromUsers = (users) => users && users.edges.length && users.edges.map((edge) => ({
  value: edge.node.pseudo, label: edge.node.pseudo, user: edge.node,
}))

class SportunityPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      autocompleteUsersQuery: '',
      autocompleteUserSelected: null,
      isEditing: props.isEditing,
      form: {},
      rejectingReason: ''
    }
  }

  componentDidUpdate(prevProps, prevState){

    let sportunity = this.props.viewer.sportunity;

    this.refs.creation_status = this._getCreationStatus(sportunity);
  }

  _handleReasonChange(event) {
    this.setState({
      rejectingReason: event.target.value
    });
  }

  onValidateButtonClick() {

    if (this.props.viewer.sportunity.number_of_occurences > 1) {
      this.dialog.show({
        title: `Modification`,
        body: `This sportunity is part of a serie. Do you want to validate all the occurences of this serie of ${this.props.viewer.sportunity.is_repeated_occurence_number} sportunities or only this sportunity ?`,
        actions: [
          Dialog.CancelAction(),
          Dialog.Action(
            'Validate only this sportunity',
            () => this.validateSportunity(false),
            'btn-info'
          ),
          Dialog.Action(
            'Validate all the serie',
            () => this.validateSportunity(true),
            'btn-danger'
          )
        ],
        bsSize: 'small',
      }) 
    }
    else {
      this.validateSportunity(false)
    }
  }

  validateSportunity = (updateSerie) => {
    let sportunity = {
      id: this.props.viewer.sportunity.id, 
      creation_status: {
        status: "VALIDATED",
        reason: ''
      },
      modifyRepeatedSportunities: updateSerie || false
    };

    this.props.onUpdateSportunity(sportunity, () => {
      this.props.relay.forceFetch({
        sportunityId: this.props.viewer.sportunity.id,
        sportunityFetch: true,
      }, state => {
      })

      this.setForm({creation_status: {status: "VALIDATED" }})
    });
  }

  onDeleteButtonClick() {
    let sportunity = {
      id: this.props.viewer.sportunity.id, 
      creation_status: {
        status: "REJECTED",
        reason: this.state.rejectingReason
      }
    };

    this.props.onUpdateSportunity(sportunity, () => {
      this.props.relay.forceFetch({
          sportunityId: this.props.viewer.sportunity.id,
          sportunityFetch: true,
        }, state => {
      })
    });
  }

  _getCreationStatus(sportunity) {
    let creation_status = "";
    if (sportunity && sportunity.creation_status && sportunity.creation_status.status)
      creation_status = sportunity.creation_status.status;

    return creation_status ;
  }

  _renderOrganizerField(organizers) {
    let organizerName = "---";
    let currentOrganizer = {}
    organizers.forEach(organizer => {
      if (organizer.isAdmin) {
        organizerName = organizer.organizer.pseudo ;
        currentOrganizer = organizer.organizer;
        return;
      }
    });

    const { isEditing } = this.state

    return (
      <div style={{display: 'flex',flexDirection:'row', paddingBottom:5, paddingTop:10, paddingLeft:20}}>
        <label>Organizer :</label>
        <div style={{paddingLeft:20, width: '75%'}}>
          {false && isEditing
            ? <Select
                options={[
                  { value: currentOrganizer.pseudo, label: currentOrganizer.pseudo, user: currentOrganizer, },
                  ...(getOptionsFromUsers(this.props.viewer.autocompleteUsers) || []),
                ]}
                value={this.state.autocompleteUsersQuery || organizerName}
                placeholder='Organizer Account'
                onChange={this._handleUserSearchSelection}
                onInputChange={this._handleUserSearchInput}
                optionRenderer={this.renderOption}
              />
            : organizerName
          }
        </div>
      </div>
    )
  }

  _renderDateField(fieldName, fieldContent) {
    const content = dateFormat(fieldContent, "dd/mm/yyyy HH:MM");

    return (
      <div>
        <div style={{display: 'flex',flexDirection:'row', paddingBottom:5, paddingTop:10, paddingLeft:20}}>
          <label>{fieldName} :</label>
          <div style={{paddingLeft:20}}>
            {content}
          </div>
        </div>
      </div>
    )
  }

  _renderTextField(fieldName, fieldContent) {
    return (
      <div style={{display: 'flex',flexDirection:'row', paddingBottom:5, paddingTop:10, paddingLeft:20}}>
        <label>{fieldName} :</label>
        <div style={{paddingLeft:20}} >
          {fieldContent}
        </div>
      </div>
    );
  }

  _renderStatusField(sportunity) {
    let status = this._getCreationStatus(sportunity);

    return (
      <div style={{display: 'flex',flexDirection:'row', paddingBottom:5, paddingTop:10, paddingLeft:20}}>
        <label>Status :</label>
        <input style={{marginLeft:10}} ref="creation_status" value={status} disabled/>
      </div>
    );
  }

  _renderSportField(sport) {
    const sportName = sport.sport.name.EN;
    const sportLogoUrl = sport.sport.logo;
    const sportLevels = (sport.allLevelSelected || !sport.levels) ? [{EN: {name:"All"}}] : sport.levels ;

    return (
      <div style={{display:'flex', flexDirection:'row'}}>
            <div style={{display: 'flex',flexDirection:'column', paddingBottom:20, marginRight:25}}>
              <label>Sport :</label>
              <div style={{paddingLeft:20}}>
                {sportName}
              </div>
              <img
                src={sportLogoUrl}
                style={{width:150, height:150}}/>
            </div>
            <div style={{display: 'flex',flexDirection:'column', paddingBottom:20}}>
              <label>Levels :</label>
              <ul className="list-group">
              {
                sportLevels.map((sportLevel, index) => (
                  <li className="list-group-item" key={index}>
                    {sportLevel.EN.name}
                  </li>
                ))
              }
              </ul>
            </div>
      </div>
    )
  }

  _renderAddressField(sportunity) {
    let address = "---";
    let venue = "---";

    if (sportunity.address)
      address = sportunity.address.address+", "+sportunity.address.city+", "+sportunity.address.country ;
    else if (sportunity.venue) {
      venue = sportunity.venue.name ;
      address = sportunity.venue.address.address+", "+sportunity.venue.address.city+", "+sportunity.venue.address.country ;
    }

    return (
      <div >
        <div style={{display: 'flex',flexDirection:'column', paddingBottom:5, paddingTop:10, paddingLeft:20}}>
          <label>Venue :</label>
          <div style={{paddingLeft:20}}>
            {venue}
          </div>
        </div>
        <div style={{display: 'flex',flexDirection:'column', paddingBottom:5, paddingTop:10, paddingLeft:20}}>
          <label>Address :</label>
          <div style={{paddingLeft:20}}>
            {address}
          </div>
        </div>
      </div>
    )
  }

  _renderValidateButton() {
    return (
      <div style={{paddingLeft:20, display:'flex', flex:1, flexDirection:'center', alignItems:'center', marginTop:20}}>
        <button type="button" className="btn btn-lg btn-success" onClick={this.onValidateButtonClick.bind(this)}>Validate</button>
      </div>
    );
  }

  _renderRejectButton(sportunity) {
    return (
      <div style={{paddingLeft:20, alignItems:'center', marginTop:20}}>
        <div>
          <label>Reason to reject the sportunity:</label>
          <input
            ref="reason"
            className="form-control"
            placeholder="Reason"
            defaultValue={sportunity.creation_status.reason || this.state.rejectingReason}
            onChange={(e) => this._handleReasonChange(e)}
          />
        </div>
        <div>
          <button style={{marginTop: 10}} type="button" className="btn btn-lg btn-danger" onClick={this.onDeleteButtonClick.bind(this)}>Reject</button>
        </div>
      </div>
    );
  }

  onModifyButtonClick = () =>
    this.setState(({ isEditing }) => ({
      isEditing: !isEditing,
    }))

  onSaveButtonClick = () =>
    this.props.viewer.sportunity.number_of_occurences > 1
    ? this.dialog.show({
        title: `Modification`,
        body: `This sportunity is part of a serie. Do you want to update all the occurences of this serie of ${this.props.viewer.sportunity.is_repeated_occurence_number} sportunities or only this sportunity ?`,
        actions: [
          Dialog.CancelAction(),
          Dialog.Action(
            'Update only this sportunity',
            () => this.props.onUpdate(this.state.form),
            'btn-info'
          ),
          Dialog.Action(
            'Update all the serie',
            () => this.props.onUpdateSerie(this.state.form),
            'btn-danger'
          )
        ],
        bsSize: 'small',
      }) 
    : this.props.onUpdate(this.state.form)

  _renderEditButton = (sportunity) =>
    <div style={{paddingLeft:20, display:'flex', flex:1, flexDirection:'center', alignItems:'center', marginTop:20}}>
      <button
        type="button"
        className={
          'btn btn-sm '+
          (this.state.isEditing? 'btn-danger' : 'btn-success')
        }
        onClick={this.onModifyButtonClick}
      >
        {this.state.isEditing? 'Cancel' : 'Modify'}
      </button>
      {this.state.isEditing &&
        <button
          type="button"
          className="btn btn-sm btn-success"
          onClick={this.onSaveButtonClick}
        >
          Save
        </button>
      }
    </div>


  _renderStatusButtons(sportunity, status) {

    if (status == "PENDING")
      return (
        <div>
          {this._renderValidateButton()}
          {this._renderRejectButton(sportunity)}
        </div>
      );
    else if (status == "VALIDATED")
      return (
        <div>
          {this._renderRejectButton(sportunity)}
        </div>
      );
    else
      return (
        <div>
          {this._renderValidateButton()}
        </div>
      );
  }

  setForm = (value) => console.log('setForm', value) || this.setState((prevState) => ({
    form: {
      ...prevState.form,
      ...value,
    },
  }))

  _handleUserSearchInput = (inputContent) => {
    clearTimeout(this._handleUserSearchInput.timeout)
    const fireIt = () => this._handleAutocompleteUserQueryChange(inputContent)
    this._handleUserSearchInput.timeout = setTimeout(fireIt, 400)
  }

  _handleAutocompleteUserQueryChange = (query) => {
    const isEmail = isValidEmailAddress(query)
    this.props.relay.setVariables({
      pseudo_autocomplete: !isEmail? query : null,
      email_autocomplete: isEmail? query : null,
      autocompletion_required: true,
    })
  }

  _handleUserSearchSelection = (option) => this.setState({
    autocompleteEmail: '',
    autocompletePseudo: option && option.label,
    autocompleteUserSelected: option && option.user,
    autocompleteUsersQuery: option.label,
  }, () => {
    this.setForm({ organizer: this.state.autocompleteUserSelected, })
  })

  renderOption = (option) => (
		<div style={{ display: 'flex', flexDirection: 'row'}}>
      <img src={option.user.avatar} style={{ height: 20, width: 'auto', padding: 4, verticalAlign: 'middle' }} />
      {option.label}
    </div>
	)


  render() {
    const { sportunity } = this.props.viewer;

    return (
      <table className="table table-hover table-condensed table-bordered">
        <tbody>
          <tr>
            <td>
              <Dialog ref={(el) => { this.dialog = el }} />
              {this._renderEditButton(sportunity)}
            </td>
          </tr>
          <tr>
            <td>
              <TextField
                fieldName="Name"
                fieldContent={sportunity.title}
                edit={this.state.isEditing}
                onChange={(title) => this.setForm({ title, })}
              />
              {this._renderOrganizerField(sportunity.organizers)}
              <DateField
                fieldName="Beginning Date"
                fieldContent={this.state.isEditing? (this.state.form.beginning_date || sportunity.beginning_date) : sportunity.beginning_date}
                edit={this.state.isEditing}
                onChange={(beginning_date) => this.setForm({ beginning_date })}
              />
              <DateField
                fieldName="Ending Date"
                fieldContent={sportunity.ending_date}
                edit={this.state.isEditing}
                onChange={(ending_date) => this.setForm({ ending_date })}
              />
              <TextField
                fieldName="Description"
                fieldContent={sportunity.description}
                type="textarea"
                edit={this.state.isEditing}
                onChange={(description) => this.setForm({ description, })}
              />
            </td>
            <td>
                <div style={{paddingLeft:20}}>
                  {this._renderSportField(sportunity.sport)}
                </div>
            </td>
            <td>
              <DateField fieldName="Creation Date" fieldContent={sportunity.creation_date}/>
              {(sportunity.cancel_date) ? <DateField fieldName="Cancel Date" fieldContent={sportunity.cancel_date}/> : ''}
              {this._renderStatusField(sportunity)}
              {this._renderStatusButtons(sportunity, sportunity.creation_status.status)}
            </td>
          </tr>
          <tr>
            <td>
              <TextField fieldName="Sex Restriction" fieldContent={sportunity.sexRestriction}/>
              <TextField fieldName="Mode" fieldContent={sportunity.mode}/>
              <TextField
                fieldName="Kind"
                fieldContent={sportunity.kind}
                type="select"
                edit={this.state.isEditing}
                options={[
                  { label: 'Private', value: 'PRIVATE' },
                  { label: 'Public', value: 'PUBLIC' },
                ]}
                value={this.state.form.kind || sportunity.kind}
                onChange={(kind) => this.setForm({ kind: kind.value })}
              />
              <TextField fieldName="Age Restriction" fieldContent={"from "+sportunity.ageRestriction.from+" to "+sportunity.ageRestriction.to}/>
            </td>
            <td>
              <TextField fieldName="Price" fieldContent={(sportunity.price) ? (sportunity.price.cents/100)+" "+sportunity.price.currency : 'Free'}/>
              {this._renderAddressField(sportunity)}
            </td>
            <td>
              { /*<UserList
                edit={this.state.isEditing}
                users={sportunity.participants}
                viewer={this.props.viewer}
              />*/ }
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
}

SportunityPanel.propTypes = ({
  sportunity : React.PropTypes.object,
  onUpdateSportunity : React.PropTypes.func.isRequired
});

export default Relay.createContainer(SportunityPanel, {
  initialVariables: {
    sportunityId: null,
    sportunityFetch: false,
    pseudo_autocomplete: null,
    email_autocomplete: null,
    autocompletion_required: false,
  },
  fragments: { 
    viewer: () => Relay.QL`
      fragment on Viewer {
        id
        sportunity(id: $sportunityId) @include (if: $sportunityFetch) {
          id
          title
          description
          address {
            address
            city
            country
          }
          venue {
            name
            address {
              address
              city
              country
            }
            owner {
              pseudo
            }
          }
          price {
            cents
            currency
          }
          mode
          kind
          ageRestriction {
            from
            to
          }
          sexRestriction
          creation_status {
            status,
            reason
          }
          sport {
            levels {
              EN {
                name
              }
            }
            allLevelSelected
            sport {
              logo
              name {
                EN
              }
            }
          }
          organizers {
            organizer {
              id
              pseudo
              avatar
            }
            isAdmin
            role
          }
          participants {
            id,
            pseudo,
            avatar
          }
          beginning_date
          ending_date
          is_repeated_occurence_number
          number_of_occurences
        }

        autocompleteUsers: users (pseudo: $pseudo_autocomplete, email: $email_autocomplete, last: 5) @include(if: $autocompletion_required) {
          edges {
            node {
              id
              pseudo
              avatar
            }
          }
        }

        ${UserList.getFragment('viewer')}
      }
    `,
  }
});



// WEBPACK FOOTER //
// ./src/components/SportunityPanel.js